export { default } from './es/icons/ZipTwoTone';